import { useUkTimeZone } from '../../../../hooks'
import { FormModalContent } from '../FormModalContent'

import { getFormModalPayload } from './FormModal.utils'

function FormModal({
  Fields,
  action,
  getPayload = getFormModalPayload,
  onSubmit,
  ...restProps
}) {
  const { timezone } = useUkTimeZone()

  function handleSubmit(values, formikHelpers) {
    onSubmit({
      ...formikHelpers,
      action,
      value: getPayload(values, timezone),
      values,
    })
  }

  return (
    <FormModalContent {...restProps} Fields={Fields} onSubmit={handleSubmit} />
  )
}

export default FormModal
